import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { CreateTagMutation, CreateTagMutationVariables } from '@/gql/graphql';

const CreateTag = graphql(`
  mutation CreateTag($input: CreateTagInput!) {
    createTag(input: $input) {
      id
    }
  }
`);

const useCreateTag = (
  options?: UseMutationOptions<
    CreateTagMutation,
    unknown,
    CreateTagMutationVariables['input']
  >
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CreateTag, {
        input,
      });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountAvailableTags(),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useCreateTag;
